import style from "./EnglishHintBar.module.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "@/ui/icon/Icon";
import { useUser } from "@/features/auth/hooks/useUser";
import { useLanguage } from "@/i18n/useLanguage";
import { browserStorage, hasAuthToken } from "@/i18n";
import {
	dismissHint,
	isEnglishEnabled,
	readStoredLanguage,
	shouldShowEnglishHint,
} from "@/i18n/language";

function browserLanguages() {
	if (typeof navigator === "undefined") return [];
	return navigator.languages?.length ? navigator.languages : [navigator.language];
}

// Written in English on purpose and never translated: it is only shown to
// people whose browser asks for English, while the site is still in Bosnian.
/* eslint-disable i18next/no-literal-string */
export default function EnglishHintBar() {
	// Re-render when another switcher changes the language: that answers the
	// question too.
	const { i18n } = useTranslation();
	const { isLoggedIn } = useUser();
	const { changeLanguage } = useLanguage();
	const [visible, setVisible] = useState(() =>
		shouldShowEnglishHint({
			enabled: isEnglishEnabled(import.meta.env),
			storage: browserStorage(),
			hasToken: hasAuthToken(),
			languages: browserLanguages(),
		})
	);

	// Already English: nothing left to offer. Covers a switch made elsewhere
	// while storage is blocked, where the stored choice can't say so.
	if (i18n.resolvedLanguage === "en") return null;
	if (!visible || isLoggedIn || readStoredLanguage(browserStorage())) return null;

	function keepBosnian() {
		dismissHint(browserStorage());
		setVisible(false);
	}

	function switchToEnglish() {
		changeLanguage("en");
		setVisible(false);
	}

	return (
		<div className={style.bar} lang="en" role="region" aria-label="Language">
			<p className={style.text}>Dekamas is available in English.</p>
			<div className={style.actions}>
				<button type="button" className={style.primary} onClick={switchToEnglish}>
					Switch to English
				</button>
				<button type="button" className={style.secondary} onClick={keepBosnian}>
					Keep Bosnian
				</button>
				<button type="button" className={style.close} aria-label="Close" onClick={keepBosnian}>
					<Icon icon="fa-xmark" />
				</button>
			</div>
		</div>
	);
}
/* eslint-enable i18next/no-literal-string */
